import { type Filters } from '~/features/mypage/types/my-page'
import { get, patch } from '~/shared/http-client/api'
import { type ApiResponse } from '~/shared/http-client/exceptions/type'

export type UserInfo = {
  id?: number
  name: string
  nickname: string
  email?: string
  year_of_birth: string
  gender?: string
}

export type UserPasswordInfo = {
  password: string
  new_password: string
}

export type PageInfo = {
  page: number
  row_per_page: number
  total_count: number
  max_page: number
  keyword: string
  category: string
  sort: string
  search: {}
}

export type UserEventTicket = {
  id: number
  ticket_type: string
  user_id: number
  user_quantity: number
  event_id: number
  event_name: string
  event_date: string
  ticket_id: number
  event_ticket_id: number
  payment_id: number
  option_1: number
  ticket_code: string
  admission_type: string
  admission_day: string
  admission_type_desc: string
  admission_day_desc: string
  used_at: string | null
  qr_code: string
}

export type UserPaymentList = {
  id: number
  event_id: number
  user_id: number
  type: string
  divide: string
  order_id: number
  order_code: string
  goods_id: number
  quantity: number
  option_1_quantity: number
  amount: number
  discount_amount: number
  option_1_amount: number
  mid: string
  currency: string
  method: string
  total_amount: number
  status: string
  requested_at: string
  approved_at: string
  approve_no: string | null
  payment_key: string
  payment_type: string
  payment_method: string | null
  error_code: string | null
  success: boolean
  usedTicketCount: number
  divide_desc: string
  status_desc: string
  can_cancle: number
}

export type UserInfoResponse = {
  id: number
  name: string
  nickname: string
  email: string
  year_of_birth: string
  gender: string
  profile_image: string | null
  status: string
  type: string
  social_login_id: string | null
  created_at: string
  updated_at: string
}

export interface MyInfoRequest {
  userInfo: UserInfo
}

export interface MyPasswordRequest {
  userInfo: UserPasswordInfo
}

export interface MyTicketListResponse extends ApiResponse {
  data: {
    pageInfo: PageInfo
    user_event_ticket_list: UserEventTicket[]
  }
}

export type UserPayment = {
  id: number
  event_id: number
  user_id: number
  type: string
  divide: string
  order_id: number
  order_code: string
  goods_id: number
  quantity: number
  option_1_quantity: number
  amount: number
  discount_amount: number
  option_1_amount: number
  mid: string
  currency: string
  method: string
  total_amount: number
  status: string
  requested_at: string
  approved_at: string
  approve_no: string | null
  payment_key: string
  payment_type: string
  payment_method: string | null
  error_code: string | null
  success: boolean
  usedTicketCount: number
  divide_desc: string
  status_desc: string
  can_cancle: number
}

export interface PaymentListResponse extends ApiResponse {
  data: {
    pageInfo: {
      page: number
      row_per_page: number
      total_count: number
      max_page: number
      keyword: string
      category: string
      sort: string
      search: {}
    }
    user_payment_list: UserPayment[]
  }
}

export interface MyInfoResponse extends ApiResponse {
  data: {
    userInfo: UserInfoResponse
  }
}

// function
export const getMyTicketList = async (filters: Filters) => {
  const params = new URLSearchParams({
    page: filters.page.toString(),
    row_per_page: filters.row_per_page.toString(),
  })

  const response = await get<MyTicketListResponse>(
    `/myPage/ticketList?${params.toString()}`,
  )

  return response.data
}

export const getPaymentList = (page: number) =>
  get<PaymentListResponse>(`/myPage/paymentList?row_per_page=10&page=${page}`)

export const getMyInfo = async () => {
  const response: MyInfoResponse = await get('/myPage')

  return response.data
}

export const patchMyInfo = (data: MyInfoRequest) => patch('/myPage', data)

export const patchMyPassword = (data: MyPasswordRequest) =>
  patch('myPage/password', data)
